import { Observable, ReplaySubject } from "rxjs";
import { DefaultNotification } from "src/app/lib/default-notification/classes";
import { DefaultMail, Issue, IssueTransaction } from "src/app/lib/issue/classes";
import { IIssueProviderService, IIssueTransactionProviderService } from "src/app/lib/issue/interfaces";

export class NavbarComponentService implements IIssueTransactionProviderService, IIssueProviderService {

    private _issue = new ReplaySubject<Issue>(1);
    private _issueId = new ReplaySubject<number>(1);
    private _issueState = new ReplaySubject<number>(1);
    private _issueTransaction = new ReplaySubject<IssueTransaction>(1);
    private _issueType = new ReplaySubject<number>(1);

    issue$: Observable<Issue> = this._issue.asObservable();
    issueId$: Observable<number> = this._issueId.asObservable();
    issueState$: Observable<number> = this._issueState.asObservable();
    issueTransaction$: Observable<IssueTransaction> = this._issueTransaction.asObservable();

    private _issueTransactionAttributes = new ReplaySubject<number[]>(1);
    issueTransactionAttributes$ = this._issueTransactionAttributes.asObservable();

    private _issueTransactionDefaultMails = new ReplaySubject<DefaultMail[]>(1);
    issueTransactionDefaultMails$: Observable<DefaultMail[]> = this._issueTransactionDefaultMails.asObservable();

    private _issueTransactionDefaultNotifications = new ReplaySubject<DefaultNotification[]>(1);
    issueTransactionDefaultNotifications$ = this._issueTransactionDefaultNotifications.asObservable();

    getCurrentIssueType = () => this._issueType.asObservable();
    provideEmptyIssue = (issue: Issue = null) => this._issue.next(issue);
    setIssueType = (type: number) => this._issueType.next(type);

    clear(){
        this._issue.next(null);
        this._issueId.next(null);
        this._issueState.next(null);
        this._issueTransaction.next(null);
        this._issueType.next(null);
    }

    setIssueTransaction(issueTransaction: IssueTransaction, attributes: number[] = [], defaultMails: DefaultMail[] = [], defaultNotifications: DefaultNotification[] = []){
        this._issueTransaction.next(issueTransaction);
        this._issueTransactionAttributes.next(attributes);
        this._issueTransactionDefaultMails.next(defaultMails);
        this._issueTransactionDefaultNotifications.next(defaultNotifications);
    }

    updateIssue(issue: Issue) {
        if(issue){
            this._issue.next(issue);
            this._issueId.next(issue.issueid);
        }
    }
}